<div class="min-h-screen py-8">
  <div class="max-w-6xl mx-auto px-4">
    <!-- Header -->
    <div class="text-center mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-2">Panel Financiero</h1>
      <p class="text-gray-600">Gestiona todas las operaciones financieras y de crédito de manera integral</p>
    </div>

    <!-- Lista de Opciones -->
    <div class="space-y-3">
      <ng-container *ngFor="let option of options">
        <ng-container *ngIf="hasPermission(option)">
          <a [routerLink]="[option.route]" class="block bg-white rounded-lg border border-gray-200 hover:border-blue-500 hover:shadow-md transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400">
            <div class="flex items-center p-4">
              <div class="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center mr-4" [ngClass]="option.color">
                <i [class]="option.icon + ' text-2xl'"></i>
              </div>
              <div class="flex-1 min-w-0">
                <h3 class="text-lg font-semibold text-gray-900">{{ option.title }}</h3>
                <p class="text-sm text-gray-600">{{ option.description }}</p>
              </div>
              <div class="flex-shrink-0 ml-4">
                <i class="fas fa-chevron-right text-gray-400"></i>
              </div>
            </div>
          </a>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>